import {
  TComponentValue,
} from '@/types/openapi-type.ts';

type TNextState = Exclude<TComponentValue<'MaintenanceState'>, 'PENDING' | 'REJECTED'>;
type TPrevState = Exclude<TComponentValue<'MaintenanceState'>, 'COMPLETED' | 'IN_REVIEW'>;
type TStageChangeButtons = {
  next: Record<TNextState, string>,
  previous: Record<TPrevState, string>,
};

const stateChangeButtons: TStageChangeButtons = {
  next: {
    // PENDING -> ASSIGNED
    ASSIGNED: 'Prijať prácu',
    // ASSIGNED -> IN_PROGRESS
    IN_PROGRESS: 'Začať prácu',
    // IN_PROGRESS -> IN_REVIEW
    IN_REVIEW: 'Dokončiť prácu',
    // IN_REVIEW -> COMPLETED
    COMPLETED: 'Schváliť prácu',
  },
  previous: {
    // ASSIGNED -> PENDING
    PENDING: 'Odmietnuť prácu',
    // IN_PROGRESS -> ASSIGNED
    ASSIGNED: 'Prerušiť prácu',
    // IN_REVIEW -> IN_PROGRESS
    IN_PROGRESS: 'Odmietnuť prácu',
    // IN_REVIEW -> REJECTED
    REJECTED: 'Odmietnuť prácu',
  },
};

export default {
  stateChangeButtons,
};
